import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools.js'
import { loading, toast } from '@/shared/utils/UIHelper'
import FollowupRepository from '@/shared/http/repositories/associate/followup'
import EventRepository from '@/shared/http/repositories/configurations/event.js'
import DespesasModal from '@/components/UI/despesasModal/despesas.vue'
import NxDatePicker from '@/components/forms/NxDatePicker.vue'

import FollowupForm from './followup-form.js'
import BoardRepositoryV2 from '@/shared/http/repositories/crm/board_v2.js'
import AccountRepository from '@/shared/http/repositories/configurations/account.js'

const FollowupData = {
  id: null,
  document: null,
  eventoId: null,
  data: null,
  horario: null,
  detalhes: null,
  autor: null,
  ip: null,
  latitude: null,
  longitude: null,
  kmInicial: 0,
  kmFinal: 0,
  despesas: [],
  cardId: null,
  boardColumnId: null,
  selectedUserId: null,
  selectedUserEmail: null
}

export default {
  name: 'ModalNewFollowUp',
  mixins: [ActionsForm],
  components: {
    DespesasModal,
    NxDatePicker
  },
  props: {
    card: {
      type: Object,
      default: () => ({})
    },
    isModal: {
      type: Boolean,
      default: false
    },
    isVisita: {
      type: Boolean,
      default: false
    },
    visitaId: {
      type: Number,
      default: null
    },
    eventManager: {
      type: Object
    },
    tipoEvento: {
      type: String,
      default: 'geral'
    }
  },
  data () {
    return {
      document: null,
      data: FollowupData,
      form: FollowupForm,
      showForm: false,
      attach: null,
      files: [],
      despesasFiles: [],
      events: [],
      showFieldsDeslocamento: false,
      showFieldsDespesas: false,
      showFieldHorario: false,
      isAgendamento: false,
      valorTotalDespesas: 0,
      formData: null,
      submited: false,
      timeout: null,
      pagingLimit: 10,
      pagingIndex: 0,
      users: [],
      filteredUsers: [],
      showSuggestions: false,
      selectedUserLink: '',
      dictUsersMentions: [],
      disabledSendFollowUp: false
    }
  },
  computed: {
    dateRequired () {
      let id = null
      if (this.form.eventoId.value) {
        this.form.eventoId.options.forEach(x => x.options.forEach((y) => {
          if (y.mnemonic === 'sys_agendamento') {
            id = y.value
          }
        }))
        if (id === this.form.eventoId.value) {
          this.form.data.required = true
          return true
        }
      }
      this.form.data.required = false
      return false
    },
    horario: {
      get: function () {
        return this.form.horario.value
      },
      set: function (value) {
        this.form.horario.value = value
      }
    }
  },
  watch: {
    card () {
      if (this.card && this.card.pessoa) {
        this.onSyncData()
      }
    }
  },
  created () {
    if (this.tipoEvento === 'rapido') {
      this.onLoadAllRapido()
    } else {
      this.onLoadAllEventType()
    }
  },
  mounted () {
    this.showModal()
  },
  methods: {
    showModal () {
      this.$refs['modal-new-followup'].show()
      // Usar horário local do navegador (fuso horário do cliente)
      const now = this.moment() // moment() usa o fuso horário local por padrão
      this.form.data.value = now.format('YYYY-MM-DD')

      // Definir horário padrão (próxima hora se já passou da atual)
      const currentHour = now.format('HH:00')
      const nextHour = now.clone().add(1, 'hour').format('HH:00')
      // Se estamos após os minutos 0, usar a próxima hora
      if (now.minute() > 0) {
        this.form.horario.value = nextHour
      } else {
        this.form.horario.value = currentHour
      }
    },
    hideModal () {
      if (!this.submited) this.aborted()
      // if (!this.eventManager) this.$refs['modal-new-followup'].hide()
      this.$emit('Reload')
    },
    aborted () {
      this.$emit('Abort')
      this.$emit('Reload')
    },
    onLoad () {
    },
    onSyncData () {
      if (this.card && this.card.pessoa) {
        this.document = this.card.pessoa.document
      }
    },
    onClear () {
      Tools.ClearDataForms(this.form, this.data)
      if (this.$refs.alert) {
        this.$refs.alert.Close()
      }
      this.files = []
      this.attach = null
      this.showFieldsDeslocamento = false
      this.showFieldsDespesas = false
      this.selectedUserLink = ''
      // Resetar estado do horário
      this.form.horario.state = null
    },
    onNew () {
      this.showForm = true
      this.files = []
      this.attach = null
    },
    onEdit (obj) {
      loading.push()
      Tools.SetValueInForm(this.form, this.data, obj)
      this.form.eventoId.value = obj.eventoDTO.id
      this.form.data.value = this.moment(obj.data).format('YYYY-MM-DD')
      this.showForm = true
      this.data.longitude = this.longitude
      this.data.latitude = this.latitude
      this.data.ip = this.ip
      loading.pop()
    },
    async storeSubmit () {
      Tools.ValidateForms(this.form, this.data, this, toast)
      await this.formatPayload()
      let submit = () => this.onCreate()
      this.$emit('Submit', submit)
      this.submited = true
      this.hideModal()
    },
    async formatPayload () {
      this.data.id = 0
      this.data.document = this.card.pessoa.document.toString().replace(/[^\d]+/g, '')
      this.data.longitude = this.longitude
      this.data.latitude = this.latitude
      this.data.visitaId = this.visitaId
      this.data.ip = this.ip
      this.data.cardId = this.card.id
      if (this.data.data) {
        if (this.data.horario && this.showFieldHorario) {
          const horarioFormatted = this.data.horario.includes(':') ? this.data.horario + ':00' : this.data.horario
          this.data.data = this.moment.tz(this.data.data + 'T' + horarioFormatted, 'America/Sao_Paulo').format('YYYY-MM-DDTHH:mm')
        } else {
          this.data.data = this.moment.tz(this.data.data + 'T' + this.moment().format('HH:mm:ss'), 'America/Sao_Paulo').format('YYYY-MM-DDTHH:mm')
        }
      }
      this.data.detalhes = await this.substituteUserForId(this.data.detalhes)

      this.formData = new FormData()
      let json = new Blob([JSON.stringify(this.data)], { type: 'application/json' })
      this.formData.append('data', json)

      if (this.files && this.files.length > 0) {
        for (let file of this.files) {
          this.formData.append('file', file)
        }
      } else {
        this.formData.append('file', [])
      }
      if (this.despesasFiles && this.despesasFiles.length > 0) {
        for (let despesasFile of this.despesasFiles) {
          this.formData.append('despesasFile', despesasFile)
        }
      } else {
        this.formData.append('despesasFile', [])
      }
    },
    async substituteUserForId (detalhes) {
      try {
        for (const username in this.dictUsersMentions) {
          if (detalhes.includes(username)) {
            detalhes = detalhes.replace(username, `<${this.dictUsersMentions[username]}>`)
          }
        }
        return detalhes
      } catch (error) {
        return detalhes
      }
    },
    async onCreate () {
      if (!this.eventManager) await this.formatPayload()
      if (this.visitaId) this.formData.visitaId = this.visitaId

      this.disabledSendFollowUp = true
      FollowupRepository.Create(this.formData)
        .then((response) => {
          if (response.status === 200) {
            if (!this.eventManager) toast.success(this.$lang.Common.Alerts.Success)
            this.attach = null
            this.files = []
            this.despesasFiles = []
            this.submited = true
            this.hideModal()
          }
          loading.pop()
        })
        .catch(this.onException)
        .finally(() => { this.disabledSendFollowUp = false })
      loading.pop()
      this.$emit('followupEmited')
    },
    onUpdate () {
      loading.push()
      this.data.id = parseInt(this.data.id)
      this.data.document = this.card.pessoa.document.toString().replace(/[^\d]+/g, '')
      this.data.longitude = this.longitude
      this.data.latitude = this.latitude
      this.data.ip = this.ip
      this.data.visitaId = this.visitaId
      if (this.data.data) {
        this.data.data = this.moment(this.data.data).format('YYYY-MM-DD') + 'T' + this.moment().format('HH:mm:ss')
      }

      let formData = new FormData()
      let json = new Blob([JSON.stringify(this.data)], { type: 'application/json' })
      if (this.files && this.files.length > 0) {
        for (let file of this.files) {
          formData.append('file', file)
        }
      } else {
        formData.append('file', [])
      }
      if (this.despesasFiles && this.despesasFiles.length > 0) {
        for (let despesasFile of this.despesasFiles) {
          formData.append('despesasFile', despesasFile)
        }
      } else {
        formData.append('despesasFile', [])
      }
      formData.append('data', json)

      this.disabledSendFollowUp = true
      FollowupRepository.Update(this.data.id, formData)
        .then((response) => {
          if (response.status === 200) {
            toast.success(this.$lang.Common.Alerts.Success)
            this.attach = null
            this.files = []
            this.despesasFiles = []
            this.submited = true
            this.hideModal()
            loading.pop()
          }
        })
        .catch(this.onException)
        .finally(() => { this.disabledSendFollowUp = false })
    },
    onDelete (obj) {
      loading.push()
      let id = parseInt(obj.id)

      FollowupRepository.Delete(id)
        .then((response) => {
          if (response.status === 200) {
            toast.success(this.$lang.Common.Alerts.Success)
            this.submited = true
            this.hideModal()
            loading.pop()
          }
        })
        .catch(this.onException)
    },
    onLoadAllEventType () {
      loading.push()
      this.form.eventoId.options = []
      const boardId = this.$route.params.boardId
      EventRepository.GetAllActive(null, this.isVisita, boardId)
        .then((response) => {
          if (response.status === 200) {
            let data = response.data.content
            if (data) {
              this.events = []
              data.forEach(x => {
                if (x.tipoEventoDTO.nome !== 'CRM') {
                  this.events.push({
                    'id': x.id,
                    'nome': x.nome,
                    'tipo': x.tipoEventoDTO.nome,
                    'deslocamento': x.deslocamento,
                    'despesa': x.despesa,
                    'mnemonic': x.mnemonic
                  })
                }
              })

              this.events.sort((a, b) => {
                let typeA = a.tipo.toLowerCase()
                let typeB = b.tipo.toLowerCase()
                if (typeA < typeB) {
                  return -1
                }
                if (typeA > typeB) {
                  return 1
                }
                return 0
              })

              let opt = []
              this.events.forEach(x => {
                if (!opt.find(opt => opt.label === x.tipo)) {
                  let options = []
                  this.events.forEach(y => {
                    if (y.tipo === x.tipo) {
                      options.push({ value: y.id, text: y.nome, mnemonic: y.mnemonic })
                    }
                  })
                  opt.push({
                    label: x.tipo,
                    options: options.sort((a, b) => a.text.localeCompare(b.text))
                  })
                  options = []
                }
              })
              this.form.eventoId.options = opt
            }
          }
          loading.pop()
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onLoadAllRapido () {
      loading.push()
      this.form.eventoId.options = []
      const boardId = this.$route.params.boardId
      EventRepository.GetAllFollowUpRapido(null, this.isVisita, boardId)
        .then((response) => {
          if (response.status === 200) {
            let data = response.data.content
            if (data) {
              this.events = []
              data.forEach(x => {
                if (x.tipoEventoDTO.nome !== 'CRM') {
                  this.events.push({
                    'id': x.id,
                    'nome': x.nome,
                    'tipo': x.tipoEventoDTO.nome,
                    'deslocamento': x.deslocamento,
                    'despesa': x.despesa,
                    'mnemonic': x.mnemonic
                  })
                }
              })

              this.events.sort((a, b) => {
                let typeA = a.tipo.toLowerCase()
                let typeB = b.tipo.toLowerCase()
                if (typeA < typeB) {
                  return -1
                }
                if (typeA > typeB) {
                  return 1
                }
                return 0
              })

              let opt = []
              this.events.forEach(x => {
                if (!opt.find(opt => opt.label === x.tipo)) {
                  let options = []
                  this.events.forEach(y => {
                    if (y.tipo === x.tipo) {
                      options.push({ value: y.id, text: y.nome, mnemonic: y.mnemonic })
                    }
                  })
                  opt.push({
                    label: x.tipo,
                    options: options.sort((a, b) => a.text.localeCompare(b.text))
                  })
                  options = []
                }
              })
              this.form.eventoId.options = opt
            }
          }
          loading.pop()
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onLoadBoardColumns () {
      let boardId = this.card.boardColumn.board.id
      BoardRepositoryV2.Column_GetAllActive(boardId)
        .then((res) => {
          this.form.boardColumnId.options = res.data.content.filter((x) => x.id != null).map((x) => {
            return x.eventoColuna === 1 ? ({'value': x.id, 'text': x.nome, disabled: true}) : ({'value': x.id, 'text': x.nome})
          })
        })
        .catch(this.onException)
    },
    onShowDespesasModal () {
      this.$refs.DespesasModal.showModal()
    },
    updateDespesasList (despesasList) {
      if (despesasList && despesasList.length) {
        this.data.despesas = despesasList

        this.data.despesas.forEach((despesa) => {
          this.valorTotalDespesas += despesa.valor
        })
      }
    },
    onChangeEvent (value) {
      this.showFieldsDeslocamento = false
      this.showFieldsDespesas = false
      this.showFieldHorario = false
      this.isAgendamento = false
      let opt = this.events.find(x => x.id === value)
      if (opt && opt.deslocamento) {
        this.showFieldsDeslocamento = true
      }
      if (opt && opt.despesa) {
        this.showFieldsDespesas = true
      }
      if (opt && opt.mnemonic === 'sys_agendamento') {
        this.isAgendamento = true
        this.showFieldHorario = true
        this.onLoadBoardColumns()
      }
    },
    onCheckKm () {
      if (this.isKmInvalid()) {
        toast.warning('ATENÇÃO: Km Inicial não pode ser maior do que o Km Final!<br>', 'FOLLOW-UP DESLOCAMENTO')
        this.form.kmInicial.value = ''
        this.form.kmFinal.value = ''
      } else if (this.isKmNegative()) {
        toast.warning('ATENÇÃO: A kilometragem não pode ser negativa!<br>', 'FOLLOW-UP DESLOCAMENTO')
        this.form.kmInicial.value < 0 ? (this.form.kmInicial.value = '') : (this.form.kmFinal.value = '')
      } else if (this.isKmZero()) {
        toast.warning('ATENÇÃO: Kilometragem rodada precisa ser maior que 0!<br>', 'FOLLOW-UP DESLOCAMENTO')
        this.form.kmInicial.value = ''
        this.form.kmFinal.value = ''
      }
    },
    isKmInvalid () {
      return this.form.kmInicial.value && this.form.kmFinal.value && this.form.kmInicial.value > this.form.kmFinal.value
    },
    isKmNegative () {
      return this.form.kmInicial.value < 0 || this.form.kmFinal.value < 0
    },
    isKmZero () {
      return this.form.kmInicial.value && this.form.kmFinal.value && this.form.kmFinal.value - this.form.kmInicial.value <= 0
    },
    onCheckDate () {
      if (this.isAgendamento) {
        if (this.moment(this.form.data.value).isBefore(this.moment().subtract(1, 'day'))) {
          toast.warning('ATENÇÃO: Data de agendamento não pode ser anterior a de hoje!<br>', 'FOLLOW-UP AGENDAMENTO')
          this.form.data.value = null
        }
      }
      // Validar horário se a data for hoje
      this.onCheckHorario()
    },
    onCheckHorario () {
      if (!this.form.data.value || !this.form.horario.value || !this.showFieldHorario) {
        return
      }

      // Usar horário local do navegador (fuso horário do cliente)
      const selectedDate = this.moment(this.form.data.value)
      const today = this.moment()

      // Se a data selecionada é hoje, verificar se o horário não é no passado
      if (selectedDate.isSame(today, 'day')) {
        // Criar datetime usando horário local
        const selectedDateTime = this.moment(this.form.data.value + ' ' + this.form.horario.value, 'YYYY-MM-DD HH:mm')
        const now = this.moment() // moment() já usa o fuso horário local por padrão

        if (selectedDateTime.isBefore(now)) {
          toast.warning('ATENÇÃO: Não é possível agendar para um horário que já passou!<br>', 'FOLLOW-UP AGENDAMENTO')
          this.form.horario.value = null
          this.form.horario.state = false
          return
        }
      }

      // Limpar estado de erro se a validação passou
      this.form.horario.state = null
    },
    onUploadClick () {
      this.$refs.inputFile.click()
    },
    onUploadDrop (event) {
      event.preventDefault()
      let files = event.dataTransfer.files
      this.attach = files
      if (files && files.length > 0) {
        for (var i in files) {
          if (files[i].size > 0) {
            this.files.push(files[i])
          }
        }
      }
    },
    onUploadDragover (event) {
      event.preventDefault()
    },
    onFileChange (event) {
      event.preventDefault()
      let files = event.target.files
      this.attach = files
      if (files && files.length > 0) {
        for (var i in files) {
          if (files[i].size > 0) {
            this.files.push(files[i])
          }
        }
      }
    },
    updateDespesasFiles (data) {
      if (data && data.length) {
        this.despesasFiles = data
      }
    },
    expandTextArea () {
      this.form.detalhes.rows !== this.form.detalhes.maxRows
        ? this.form.detalhes.rows = this.form.detalhes.maxRows
        : this.form.detalhes.rows = this.form.detalhes.minRows
    },
    handleInput (event) {
      const input = event.target.value
      const cursorPosition = event.target.selectionStart // Posição do cursor

      const atIndex = input.lastIndexOf('@', cursorPosition - 1)

      if (atIndex !== -1) {
        const searchTerm = input.substring(atIndex + 1, cursorPosition).trim()

        if (searchTerm.length > 0) {
          this.showSuggestions = true
          this.debounceSearch(searchTerm)
        } else {
          this.showSuggestions = false
        }
      } else {
        this.showSuggestions = false
      }
    },
    getSelectedUsername () {
      if (this.selectedUserLink) {
        const match = this.selectedUserLink.match(/@([a-zA-Z0-9_]+)/)
        return match ? match[1] : null
      }
      return null
    },

    debounceSearch (searchTerm) {
      clearTimeout(this.timeout)

      this.timeout = setTimeout(() => {
        this.onLoadAllUsers(searchTerm)
      }, 300)
    },
    onLoadAllUsers (searchTerm) {
      if (searchTerm.length > 0) {
        AccountRepository.SearchSimplifiedUser(searchTerm, this.pagingLimit, this.pagingIndex)
          .then((response) => {
            this.filteredUsers = response.data.content
            this.showSuggestions = this.filteredUsers.length > 0
          })
          .catch((err) => {
            console.error('Erro ao buscar usuários:', err)
            this.showSuggestions = false
          })
      } else {
        this.showSuggestions = false
      }
    },
    selectUser (user) {
      const inputValue = this.form.detalhes.value
      const cursorPosition = this.$refs.txtDetalhes.selectionStart
      const atIndex = inputValue.lastIndexOf('@', cursorPosition - 1)
      const newValue = `${inputValue.substring(0, atIndex)}@${user.username} ${inputValue.substring(cursorPosition)}`

      this.form.detalhes.value = newValue

      this.selectedUserLink = `<a href="#" class="custom-link" data-vss-mention="${user.id}">@${user.username}</a>`
      this.dictUsersMentions[user.username] = user.id

      this.form.selectedUserId.value = user.id
      this.form.selectedUserEmail.value = user.emailCorporativo

      this.showSuggestions = false
      this.filteredUsers = []
    },
    onException (err) {
      console.error('Erro na busca:', err)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/crm/details/followup/followup.js